import { render, staticRenderFns } from "./DefinedTipsAmount.vue?vue&type=template&id=8e10132c&scoped=true&"
import script from "./DefinedTipsAmount.vue?vue&type=script&lang=js&"
export * from "./DefinedTipsAmount.vue?vue&type=script&lang=js&"
import style0 from "./DefinedTipsAmount.vue?vue&type=style&index=0&id=8e10132c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e10132c",
  null
  
)

export default component.exports